<!-- <i class="glyphicons glyphicons-refresh"></i> -->
<!-- <app-button-switch [isUpDown]="true"></app-button-switch>  -->
<div class="map-icon">
    <mat-icon class="icon-general" svgIcon="icon-reverse"></mat-icon>
</div>
